import { render } from "./QuestionKey.vue?vue&type=template&id=62ec3c17"
import script from "./QuestionKey.vue?vue&type=script&lang=js"
export * from "./QuestionKey.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__